import { useMemo, useState } from 'react';

function arr(v: any): any[] {
  if (!v) return [];
  if (Array.isArray(v)) return v;
  if (typeof v === 'object') return Object.values(v).flat().filter(Boolean);
  return [v];
}

function pick(o: any, keys: string[]) {
  for (const k of keys) {
    const v = o?.[k];
    if (v) return v;
  }
  return null;
}

export default function GovernorLiveTimeline({ runtime }: { runtime: any }) {
  const [filter, setFilter] = useState('all');

  const rows = useMemo(() => {
    const findings = arr(pick(runtime, ['findings', 'report']));
    const repairs = arr(pick(runtime, ['repairQueue', 'autoRepairQueue', 'repairs']));
    const events = arr(pick(runtime, ['treeGovernorEvents', 'runtimeEvents', 'timeline', 'events']));

    return [
      ...events.map((x: any) => ({ type: 'event', ...x })),
      ...findings.map((x: any) => ({ type: 'finding', ...x })),
      ...repairs.map((x: any) => ({ type: 'repair', ...x })),
    ];
  }, [runtime]);

  const visible = filter === 'all' ? rows : rows.filter((r: any) => r.type === filter);

  return (
    <section className="rounded-[2rem] bg-white p-6 mb-6 shadow-sm">
      <h2 className="text-4xl mb-3">Live Governor Timeline</h2>
      <p className="text-slate-600 mb-4">
        Filtered runtime history from events, findings, and repair recommendations.
      </p>

      <div className="flex flex-wrap gap-2 mb-5">
        {['all', 'event', 'finding', 'repair'].map((x) => (
          <button
            key={x}
            onClick={() => setFilter(x)}
            className={`rounded-full px-4 py-2 border text-sm ${filter === x ? 'bg-slate-900 text-white' : 'bg-white text-slate-700'}`}
          >
            {x}
          </button>
        ))}
      </div>

      {visible.length === 0 ? (
        <div className="rounded-2xl bg-amber-50 border border-amber-200 p-4 text-slate-700">
          No timeline events yet. Trigger a real tree action, repair, message, call, login, or deploy to populate this panel.
        </div>
      ) : (
        <div className="space-y-3">
          {visible.slice(0, 25).map((item: any, i: number) => (
            <div key={item.id || item.runtimeEvidenceId || i} className="rounded-2xl bg-emerald-50 border border-emerald-100 p-4">
              <div className="font-bold">{item.title || item.action || item.kind || item.type || `Timeline item ${i + 1}`}</div>
              <div className="text-sm text-slate-700">type: {item.type}</div>
              {item.reason ? <div className="text-sm text-slate-700">reason: {item.reason}</div> : null}
              {item.suggestedNextAction ? <div className="text-sm text-slate-700">next: {item.suggestedNextAction}</div> : null}
              {item.runtimeEvidenceId ? <div className="text-xs text-slate-500">evidence: {item.runtimeEvidenceId}</div> : null}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
